import { useEffect, useRef, useState } from 'react';
import toNumber from 'lodash/toNumber';

import TextInput from 'components/_other/form/TextInput';

import styles from 'components/_other/form/NumberInput.module.scss';
import { isFunction } from 'lodash';
import LoadingIcon from '@/components/_other/icons/LoadingIcon';

const Loader = () => {
  return (
    <div
      className="absolute top-0 -left-2 -right-2 bottom-0 bg-white z-50 bg-opacity-50 flex items-center justify-center">
      <LoadingIcon className="w-[35px]" />
    </div>
  );
};

const NumberInput = (props) => {
  const {
    inputProps,
    increaseIcon = '+',
    decreaseIcon = '-',
    showButtons = true,
    loading = false,
    error,
    onValueChange,
    ...rest
  } = props;
  const { name, value: defaultValue = 1, min = 1, max, onChange, readOnly, groupClassName, hasFeedback, ...restInputProps } = inputProps;
  const inputRef = useRef();
  const [value, setValue] = useState(defaultValue);

  const processValue = (value) => {
    let newValue = toNumber(value);
    const minNumber = toNumber(min);
    const maxNumber = toNumber(max);

    if (newValue > maxNumber) {
      newValue = maxNumber;
    } else if (newValue < minNumber) {
      newValue = minNumber;
    } else if (newValue < min) {
      newValue = min;
    }

    return newValue;
  };

  const handleIncrease = (e) => {
    e.preventDefault();
    const newValue = processValue(value + 1);
    setValue(processValue(value + 1));

    if (isFunction(onValueChange)) {
      onValueChange(newValue);
    }
  };

  const handleDecrease = (e) => {
    e.preventDefault()
    const newValue = processValue(value - 1);
    setValue(newValue);

    if (isFunction(onValueChange)) {
      onValueChange(newValue);
    }
  };

  const handleChange = (e) => {
    setValue(processValue(e?.target?.value));
  };

  const handleBlur = (e) => {
    const newValue = processValue(e?.target?.value);

    setValue(newValue);
    if (isFunction(onValueChange)) {
      onValueChange(newValue);
    }
  };

  useEffect(() => {
    if (isFunction(onChange)) {
      onChange(value);
    }
  }, [value, onChange]);

  // Update internal value when defaultValue changes
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  let before, after = null;
  if (showButtons) {
    before = <button type="button" disabled={value <= min} className={styles?.decrease} onClick={handleDecrease}>
      {decreaseIcon}
    </button>;

    after = <button type="button" disabled={value >= max} className={styles?.increase} onClick={handleIncrease}>
      {increaseIcon}
    </button>;
  }


  return (
    <div className={`${styles?.inputGroup} ${groupClassName}`}>
      {loading ? <Loader /> : null}
      <TextInput
        type="text"
        name={name}
        error={error}
        before={before}
        after={after}
        {...rest}
        inputProps={{
          ...restInputProps,
          ...{
            groupClassName: groupClassName,
            className: '!border-none !bg-transparent',
            readOnly: readOnly || loading,
            min: min ?? 1,
            step: 1,
            value: value,
            type: 'text',
            ref: inputRef,
            pattern: '[0-9]*',
            onChange: handleChange,
            onBlur: handleBlur,
          },
        }}
      />
    </div>
  );
};

export default NumberInput;
